// Click handler for [data-share="…"] buttons inside any popover.
// Opens the right share URL or copies the page URL to the clipboard.
import { delegate, qs } from '../lib/dom.js';
import { t } from '../lib/i18n.js';

function showToast(message) {
  const toast = qs('[data-role="toast"]');
  const msg = qs('[data-role="toast-message"]');
  if (!toast) return;
  if (msg) msg.textContent = message;
  toast.classList.add('is-visible');
  setTimeout(() => toast.classList.remove('is-visible'), 2400);
}

export function initShare() {
  delegate(document, 'click', '[data-share]', (e, btn) => {
    e.preventDefault();
    const action = btn.dataset.share;
    const url = window.location.href;
    const enc = encodeURIComponent(url);
    const title = encodeURIComponent(document.title);

    switch (action) {
      case 'copy':
        if (navigator.clipboard) {
          navigator.clipboard.writeText(url)
            .then(() => showToast(t('share_copied', 'Link copiat în clipboard')))
            .catch(() => showToast(t('share_copy_failed', 'Nu am putut copia link-ul')));
        }
        break;
      case 'whatsapp':
        window.open(`https://wa.me/?text=${title}%20${enc}`, '_blank', 'noopener,noreferrer');
        break;
      case 'telegram':
        window.open(`https://t.me/share/url?url=${enc}&text=${title}`, '_blank', 'noopener,noreferrer');
        break;
      case 'facebook':
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${enc}`, '_blank', 'noopener,noreferrer,width=600,height=500');
        break;
      case 'twitter':
        window.open(`https://twitter.com/intent/tweet?url=${enc}&text=${title}`, '_blank', 'noopener,noreferrer');
        break;
      case 'email':
        window.location.href = `mailto:?subject=${title}&body=${enc}`;
        break;
    }
  });

  // Share / message popovers are CSS-only <details>, which natively stay open
  // until their own summary is clicked again. Close any open one when the user
  // clicks outside it or presses Escape. Scoped to these popovers by class so
  // the catalog filter <details> (and other accordions) are left alone.
  const OPEN_SEL = [
    'ap-cd-share-desk',
    'ap-cd-share-top',
    'ap-listing-card__msg',
    'ap-location-card__msg',
  ].map((c) => `details.${c}[open]`).join(', ');

  document.addEventListener('click', (e) => {
    const open = document.querySelectorAll(OPEN_SEL);
    if (!open.length) return;
    open.forEach((d) => {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll(OPEN_SEL).forEach((d) => d.removeAttribute('open'));
  });
}
